import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import el from './locales/el.json'
import en from './locales/en.json'
import ru from './locales/ru.json'

export const LANGUAGES = [
  { code: 'en', label: 'EN' },
  { code: 'el', label: 'ΕΛ' },
  { code: 'ru', label: 'RU' },
]

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, ru: { translation: ru }, el: { translation: el } },
    fallbackLng: 'en',
    supportedLngs: LANGUAGES.map((l) => l.code),
    interpolation: { escapeValue: false },
  })

/** Pick a translation from an API i18n object like {"en": "...", "ru": "..."}. */
export function pickI18n(obj, lang) {
  if (!obj) return ''
  return obj[lang] || obj.en || Object.values(obj)[0] || ''
}

export default i18n
